import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class WarehouseService {
  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  // Get User Requirements List
  getWarehouseRequirementsList(data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}admin/getWarehouseRequirements`,
      data,
    );
  }

  // Get User Requirement By Id
  getWarehouseRequirementById(data: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}admin/getWarehouseRequirementById`,
      data,
    );
  }
}
